import _ from 'lodash';
import { useState } from 'react';
import { Stack, Box, Typography, Divider, useTheme } from '@mui/material';
import { HeaderPage1 } from 'theme/elements/Headers';
import { Tooltip } from 'theme/elements/Tooltip';
import { FormButton, GeneralButton } from 'theme/elements/Buttons';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
import {
  getExistingContacts,
  isLoading,
} from 'state/reducers/contact.reducers';
import { obj, OrderBy } from 'constants/global.constants';
import { ContactId, ContactsTableColumns, ContactsTableDefaultSort } from 'constants/contact.constants';
import CancelDialog from 'components/CancelDialog';
import BasicTable from 'components/BasicTable';
import { columnType, Order } from 'components/BasicTable/types';
import { getMobile } from 'state/reducers/ui.reducers';
import WaitingMessage from 'components/WaitingMessage';

export default function Contacts() {
  const t = useAppSelector(selectTranslations);
  const contacts = useAppSelector(getExistingContacts);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const isMobile = useAppSelector(getMobile);
  const theme = useTheme();
  const prefixFields = 'page.settings.contacts.';
  const imageUrl = useAppSelector(selectImageUrl);
  const getContactsTableColumns = () => {
    const columns: columnType[] = [];
    _.keys(ContactsTableColumns).forEach((element) => {
      const props: columnType = {
        fieldId: ContactId,
        name: element,
        title: t(prefixFields + 'table.column.' + _.snakeCase(element) + '.text'),
        type: ContactsTableColumns[element],
      };
      columns.push(props);
    });
    return columns;
  };
  const loading: boolean = useAppSelector(isLoading);

  const foramtValues = (contactsFromServer: obj[]) => {
    const displayedListData: obj[] = [];
    contactsFromServer.forEach((contact) => {
      const displayedContact: obj = {
        [ContactId]: _.get(contact, ContactId),
      };
      _.keys(ContactsTableColumns).forEach((key) => {
        switch (key) {
          case 'fullName':
            displayedContact[key] = `${contact.firstName} ${contact.lastName}`;
            break;
          case 'permission':
            displayedContact[key] = t(
              prefixFields + 'permission.' + _.snakeCase(String(contact[key])) + '.text'
            );
            break;
          default:
            displayedContact[key] = contact[key] || '';
        }
      });
      displayedListData.push(displayedContact);
    });
    return displayedListData;
  };

  const createRemoveContactRequest = () => {
    setShowRemove(true);
  };

  const sendRemoveContactNotificationRequest = () => {
    setShowTooltip(true);
  };

  if (loading) {
    return <WaitingMessage title="getting there..." imageKey="page.settings.bank_accounts.loading.icon" />;
  }

  return (
    <>
      <Stack spacing={5}>
        <Stack
          justifyContent={'space-between'}
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 2, sm: 0 }}
          divider={isMobile && <Divider orientation="horizontal" flexItem />}
        >
          <HeaderPage1 title={t(prefixFields + 'title')} />
        </Stack>
        <Box sx={{ '& .tableActionsWrap': { [theme.breakpoints.down('sm')]: { width: '100%' } } }}>
          <BasicTable
                // actionsCell={
                // 	userPermission === UserPermission.SIGNER
                // 		? [
                // 				{
                // 					element: (
                // 						<FormButton>
                // 							<GeneralButton height="inherit">
                // 								<Button
                // 									size={isMobile ? 'small' : 'large'}
                // 									className="hiddenActions"
                // 									variant={!isMobile ? 'contained' : 'outlined'}
                // 									fullWidth
                // 								>
                // 									{t(prefixFields + 'ask_to_remove_button.text')}
                // 								</Button>
                // 							</GeneralButton>
                // 						</FormButton>
                // 					),
                // 					onClick: (row) => {
                // 						createRemoveContactRequest();
                // 					},
                // 				},
                // 		  ]
                // 		: undefined
                // }
            fieldId="id"
            rowsClass="hoverButton"
            data={foramtValues(contacts)}
            columns={getContactsTableColumns()}
            defaultSortBy={ContactsTableDefaultSort}
            defaultOrderBy={OrderBy.ACSENDING as Order}
          />
        </Box>
      </Stack>
      {showTooltip && (
        <Tooltip
          dismissLabel={t(prefixFields + 'tooltip.dismiss_button.text')}
          handleClick={() => setShowTooltip(false)}
          styleObj={{ right: '5%', bottom: '5%' }}
        >
          <Typography>
            {t(prefixFields + 'remove.success_tooltip.text')}
          </Typography>
        </Tooltip>
      )}
      {showRemove && (
        <CancelDialog
          open={showRemove}
          handleCancel={() => {
            setShowRemove(false);
            sendRemoveContactNotificationRequest();
          }}
          handleContinue={() => setShowRemove(false)}
          cancelLabel={`${t(prefixFields + 'remove_popup.continue_button.text')}`}
          continueLabel={`${t(prefixFields + 'remove_popup.cancel_button.text')}`}
          title={t(prefixFields + 'remove_popup.title')}
          subTitle={t(prefixFields + 'remove_popup.text')}
          popupIcon={imageUrl(prefixFields + 'remove_popup.icon')}
        />
      )}
    </>
  );
}
